import { createStore } from "redux";

// ✅ Initial State
const initialState = {
  user: null,
};
 
// ✅ Reducer Function
function rootReducer(state = initialState, action) {
    switch (action.type) {
        case "SET_VALUE":
          if (action.key) {
            return { ...state, [action.key]: action.value };
          }
          return state;
        default:
          return state;
      }
}

// ✅ Create Store
const store = createStore(rootReducer);

export default store;
